import { useSelector } from 'react-redux';

import { Roles } from '../../../constants';
import { areUserRolesIn } from '../../../helpers/auth-helpers';

import type { RootState } from '../../../store';

// The treatment plan route admits every role that can view a plan (VBT, billing, QA, guardians),
// so v3 stays view-only for them and only the BCBA can edit.
export default function useIsTreatmentPlanV3ReadOnly(): boolean {
  const userRoles = useSelector((state: RootState) => state.auth.user?.roles);

  return !areUserRolesIn(userRoles, [Roles.Bcba]);
}
